import { Grid, styled } from '@mui/material';
import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

const BANNER_PADDING_TOP = '75px';

const classes = {
  root: {
    marginTop: '71px',
    [theme.breakpoints.up('md')]: {
      marginTop: '71px',
    },
  },
  toolTipButton: {
    position: 'fixed',
  },
  allResults: {
    textAlign: 'right',
    width: '96%',
    padding: '6px 18px',
    [theme.breakpoints.up('md')]: {
      backgroundColor: `${COLORS.gray.light7}`,
      display: 'flex',
      flexDirection: 'column',
      padding: '6px 0',
    },
  },
  bannerWidget: (props: { isMoreFiltersOpen: boolean }) => ({
    position: 'relative',
    width: '100%',
    marginTop: props.isMoreFiltersOpen ? '60px' : '0px',
  }),
  closeButton: {
    position: 'absolute',
    maxHeight: '32px',
    maxWidth: '32px',
    top: '8px',
    left: '8px',
    cursor: 'pointer',
  },
  bannerContainer: {
    paddingTop: '52px',
    backgroundColor: `${COLORS.white.secondary}`,
    [theme.breakpoints.up('md')]: {
      width: '100%',
      paddingTop: BANNER_PADDING_TOP,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  sortFilterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'end',
  },
};

export default classes;

export const cardsContainer = {
  display: 'flex',
  justifyContent: 'center',
  rowGap: '21px',
  paddingBottom: '50px',
  maxWidth: '1990px',
  backgroundColor: `${COLORS.gray.light7}`,

  [theme.breakpoints.up(700)]: {
    marginBottom: '56px',
    backgroundColor: `${COLORS.gray.light7}`,
    columnGap: '20px',
    rowGap: '18px',
    justifyContent: 'start',
    padding: '0 2.5% 70px 0',
    margin: 'auto',
  },

  [theme.breakpoints.up('md')]: {
    marginBottom: '56px',
    backgroundColor: `${COLORS.gray.light7}`,
    columnGap: '20px',
    rowGap: '18px',
    justifyContent: 'start',
    padding: '0 2.5% 70px 0',
    margin: 'auto',
  },
};

export const cardContainer = {
  width: 'calc(100% - 32px)',

  [theme.breakpoints.up(700)]: {
    width: 'calc(50% - 20px)',
  },
  [theme.breakpoints.up(1200)]: {
    width: 'calc(33% - 20px)',
  },
  [theme.breakpoints.up(1300)]: {
    width: 'calc(25% - 20px) !important',
  },
};

export const cardsContainerSeo = {
  margin: '0 14px',

  [theme.breakpoints.up('md')]: {
    margin: '0 0 0 3.5%',
  },
};
export const resultPageTitle = {
  fontSize: '32px',
  lineHeight: 1.3,
  textAlign: 'right',
  width: '100%',
  backgroundColor: `${COLORS.gray.light7}`,
  padding: '24px 0 6px 0',
};

export const getResultPageTitleStyle = (title: string, isMobile: boolean) => {
  let style = { ...resultPageTitle };

  if (isMobile && title.length > 18) {
    style = {
      ...style,
      fontSize: '25px',
    };
  }

  if (isMobile && title.length > 25) {
    style = {
      ...style,
      fontSize: '20px',
    };
  }

  return style;
};

export const sortByStyle = {
  fontSize: '16px',
  color: '#838383',
};

export const selectInputStyle = {
  fontSize: '16px',
  height: 'unset',
  color: '#838383',
};

export const CloseButtonIcon = styled('svg')(() => ({
  position: 'absolute',
  maxHeight: '32px',
  maxWidth: '32px',
  top: '8px',
  left: '8px',
  cursor: 'pointer',
}));

export const BannerWidget = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));

export const visuallyHidden = {
  overflow: 'hidden',
  width: '0px',
  height: '0px',
};

export const StyledButtonWidgetGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '30px',
  [theme.breakpoints.up('md')]: {
    marginTop: '38px',
  },
});

export const customPaginationButtonStyles = {
  width: '281px',
  height: '40px',
};
